/* About-only labels for inherited asynchronous app frames. */
(() => {
  class AboutAccessibility extends HTMLElement {
    connectedCallback() {
      this.observer = new MutationObserver(() => this.labelFrames());
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.labelFrames();
      this.timeout = setTimeout(() => this.observer.disconnect(), 30000);
    }

    labelFrames() {
      const frames = [
        ['PBarNextFrame', 'Shopify theme preview controls'],
        ['merchantwidgetiframe', 'Google store information']
      ];
      let found = 0;
      for (const [id, title] of frames) {
        const frame = document.getElementById(id);
        if (frame) {
          if (!frame.title) frame.title = title;
          found += 1;
        }
      }
      if (found === frames.length) this.observer.disconnect();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.timeout);
    }
  }
  if (!customElements.get('about-accessibility')) {
    customElements.define('about-accessibility', AboutAccessibility);
  }
})();
